<section id="market-watch" class="jobs" [dir]="'Direction' | translate">
  <div class="container" data-aos="fade-up" data-aos-duration="1000">
    <div class="jobs-inner">
      <!-- Stock Selector Dropdown -->
      <div class="dropdown-container">
        <h3 class="bigger-text" for="stockSelector" [dir]="'Direction'| translate">{{ "SelectStock" | translate }}</h3>
        <select id="stockSelector" class="form-control" [(ngModel)]="isin" (change)="onStockChange($event.target.value)">
          <option *ngFor="let stock of allStocks" [value]="stock.isin">{{ stock.englishName }}</option>
        </select>
      </div>

      <!-- Table Container -->
      <div *ngIf="stockDetails" class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>{{ "Name" | translate }}</th>
              <th>{{ "symbol" | translate }}</th>
              <th>{{ "open" | translate }}</th>
              <th>{{ "close" | translate }}</th>
              <th>{{ "change" | translate }}</th>
              <th>{{ "lastPrice" | translate }}</th>
              <th>{{ "tradesCount" | translate }}</th>
              <th>{{ "askVolume" | translate }}</th>
              <th>{{ "bidVolume" | translate }}</th>
              <th>{{ "highBidPrice" | translate }}</th>
              <th>{{ "lowAskPrice" | translate }}</th>
              <th>{{ "value" | translate }}</th>
              <th>{{ "volume" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ stockDetails.englishName }}</td>
              <td>{{ stockDetails.symbol }}</td>
              <td>{{ stockDetails.open }}</td>
              <td>{{ stockDetails.close }}</td>
              <td [ngClass]="{'text-success': stockDetails.change > 0, 'text-danger': stockDetails.change < 0}">
                {{ stockDetails.change }}
              </td>
              <td>{{ stockDetails.lastPrice }}</td>
              <td>{{ stockDetails.tradesCount }}</td>
              <td>{{ stockDetails.askVolume }}</td>
              <td>{{ stockDetails.bidVolume }}</td>
              <td>{{ stockDetails.highBidPrice }}</td>
              <td>{{ stockDetails.lowAskPrice }}</td>
              <td>{{ stockDetails.value }}</td>
              <td>{{ stockDetails.volume }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Chart and Info Container -->
      <div class="info-chart-container">
        <div *ngIf="!loading" class="chart-container">
          <canvas baseChart
            [datasets]="lineChartData"
            [labels]="lineChartLabels"
            [options]="lineChartOptions"
            [type]="lineChartType"
            [legend]="lineChartLegend">
          </canvas>
        </div>
        <div [ngClass]="{'loader': loading}"></div>
        <div *ngIf="!loading" class="details-section-container">
          <h3 class="bigger-text">{{ "Additional Information" | translate }}</h3>
          <div class="details-section">
            <div>
              <p class="bigger-text">{{ "Address" | translate }}</p>
              <p>{{ stockAdditionalDetails?.address }}</p>
            </div>
            <div>
              <p class="bigger-text">{{ "Telephone" | translate }}</p>
              <p>{{ stockAdditionalDetails?.telephone }}</p>
            </div>
            <div>
              <p class="bigger-text">{{ "Fax" | translate }}</p>
              <p>{{ stockAdditionalDetails?.fax }}</p>
            </div>
            <div>
              <p class="bigger-text">{{ "Capital" | translate }}</p>
              <p>{{ stockAdditionalDetails?.capital }}</p>
            </div>
            <div>
              <p class="bigger-text">{{ "Email" | translate }}</p>
              <p>{{ stockAdditionalDetails?.email }}</p>
            </div>
            <div>
              <p class="bigger-text">{{ "Board Members" | translate }}</p>
              <p><span [innerHTML]="stockAdditionalDetails?.boardMembers"></span></p>
            </div>
          </div>
        </div>
      </div>

      <div class="info-news-container">
        <!-- Dividends -->
        <div class="dividends-column">
          <h3 class="bigger-text">{{ "Dividends" | translate }}</h3>
          <div class="dividends-table-container">
            <ng-container *ngIf="dividendsData && dividendsData.length > 0; else noDividends">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>{{ "Company" | translate }}</th>
                      <th>{{ "Currency" | translate }}</th>
                      <th>{{ "Address" | translate }}</th>
                      <th>{{ "Number" | translate }}</th>
                      <th>{{ "Value" | translate }}</th>
                      <th>{{ "MaturityDate" | translate }}</th>
                      <th>{{ "PayDate" | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let dividend of dividendsData">
                      <td>{{ dividend.divCompName }}</td>
                      <td>{{ dividend.divCurrency }}</td>
                      <td>{{ dividend.divAddess }}</td>
                      <td>{{ dividend.divNumber }}</td>
                      <td>{{ dividend.divValue }}</td>
                      <td>{{ dividend.divMatDate }}</td>
                      <td>{{ dividend.divPayDate }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>
            <!-- No Dividends Message -->
            <ng-template #noDividends>
              <div class="no-content-message text-center">
                {{ "There's no information available" | translate }}
              </div>
            </ng-template>
          </div>
        </div>

        <!-- News -->
        <div class="news-column">
          <h3 class="bigger-text">{{ "News.Title" | translate }}</h3>
          
          <div *ngIf="!selectedArticle" class="news-container">
            <div *ngFor="let news of paginatedStockNews" class="news-item" (click)="selectNews(news)">
              <h4>{{ news.newsHeader }}</h4>
              <p>{{ news.formattedDate }}</p>
              <button>{{ "News.ReadMore" | translate }}</button>
            </div>

            <!-- Pagination -->
            <div class="pagination-controls" *ngIf="totalPages > 1">
              <button [disabled]="currentPage === 1" (click)="prevPage()">
                {{ "News.Previous" | translate }}
              </button>
              <span>{{ "News.Page" | translate }} {{ currentPage }} {{ "News.Of" | translate }} {{ totalPages }}</span>
              <button [disabled]="currentPage === totalPages" (click)="nextPage()">
                {{ "News.Next" | translate }}
              </button>
            </div>
          </div>

          <!-- Details -->
          <div *ngIf="selectedArticle" class="news-details">
            <button (click)="deselectNews()">{{ "News.Back" | translate }}</button>
            <h3>{{ selectedArticle.newsHeader }}</h3>
            <p [innerHTML]="selectedArticle.newsDetails"></p>
            <div *ngIf="selectedArticle.newsAttachment" class="news-attachment">
              <a [href]="selectedArticle.newsAttachment" download>{{ 'Download Attachment' | translate }}</a>
            </div>
          </div>
        </div>
        

      </div>
      <app-bonus-assemblies [stockIsin]="isin"></app-bonus-assemblies>
    </div>
    
  </div>
  
</section>
